"use client";

import { useTranslations } from "next-intl";
import { usePopularShops } from "@/hooks/queries";
import { ScrollTile } from "@/components/scroll-tile";
import { HorizontalScrollRow } from "@/components/horizontal-scroll-row";
import { TileSection } from "@/components/sections/tile-section";
import { SCROLL_TILE_WIDTH } from "@/lib/constants";

export function PopularShopsGrid() {
  const t = useTranslations("projects");
  const { data, isLoading } = usePopularShops({ size: 11 });
  const shops = data?.content ?? [];

  return (
    <TileSection
      title={t("detail.supportViaShopping")}
      isLoading={isLoading}
      isEmpty={shops.length === 0}
      seeAllHref="/shops"
      seeAllLabel={t("detail.allShops")}
    >
      <HorizontalScrollRow>
        <div className={`shrink-0 ${SCROLL_TILE_WIDTH}`}>
          <ScrollTile
            href="/shops/amazon"
            name="Amazon"
            logoUrl="/start/amazon-logo.png"
            className="bg-[#FF9900]/10"
          />
        </div>
        {shops.map((shop) => (
          <div key={shop.id} className={`shrink-0 ${SCROLL_TILE_WIDTH}`}>
            <ScrollTile
              href={`/shops/${shop.slug}`}
              name={shop.name ?? ""}
              logoUrl={shop.logoUrl}
              shopId={shop.id}
              commissionRangeSummary={shop.commissionRangeSummary}
            />
          </div>
        ))}
      </HorizontalScrollRow>
    </TileSection>
  );
}
